export const OfferBannerTheme = {
  standard: 'standard',
  shadowed: 'shadowed'
} as const;
export type OfferBannerTheme = (typeof OfferBannerTheme)[keyof typeof OfferBannerTheme];

export const themeClassNameMap = {
  [OfferBannerTheme.standard]: '',
  [OfferBannerTheme.shadowed]: 'offerBanner--shadowed'
};

export const query = {
  'min-width-710': {
    minWidth: 710
  }
};
